import { network } from 'services/network';

export const renameVersion = (params) => {
    return network.post('api/bo/renameVersion', params).then((response) => {
        return response.data;
    });
};
